import { Share2 } from "lucide-react";
import { PageHeader } from "@/components/Layout/PageHeader";
import { SocialHubView } from "./SocialHubView";

export function SocialHubPage() {
  return (
    <div>
      <PageHeader
        icon={Share2}
        title="Social Hub"
        description="Your central command for all social media activity. Compose and schedule posts, monitor your inbox, track engagement, manage campaigns, and view analytics — all from one place."
      />
      <SocialHubView />
    </div>
  );
}
